const level2leaf = true;

export const doelNL = {
  title: 'Kerndoelen Nederlands (2026)',
  href: 'https://www.slo.nl/thema/meer/actualisatie-kerndoelen-examenprogramma/actualisatie-kerndoelen/@25214/kerndoelen-voortgezet-onderwijs/',
  color: '#fa9664',
  col3orScale: 'Oranges',
  children: {
    'Communicatie': {
      children: {
        'Tekstbegrip': {
      code: '2',
      children: {
        'Begrip': {
          code: '2A',
          description: 'De leerling toont begrip van zakelijke en literaire teksten',
          isLeaf: level2leaf,
          children: {
            'Aandachtig lezen, kijken, luisteren': {
              code: '2A1',
              description: 'Aandachtig luisteren, kijken of aandachtig vloeiend lezen'
            },
            'Woordenschat, wereldkennis': {
              code: '2A2',
              description: 'Inzetten en uitbreiden van woordenschat, kennis over taal en kennis van de wereld'
            },
            'Kennis over teksten': {  
              code: '2A3',
              description: 'Inzetten en uitbreiden van kennis over de vorm van teksten: tekstsoorten, tekststructuren, literaire genres, verteltechnieken'
            },
            'Perspectief, publiek, doel, context': {
              code: '2A4',
              description: 'Beschrijven van perspectieven, communicatieve doelen, publiek, context'
            },
            'Hoofd- en bijzaken, betekenis': {
              code: '2A5',
              description: 'In eigen woorden weergeven van de hoofd- en bijzaken, de hoofdgedachte en betekenis van een tekst, passend bij het lees- of luisterdoel'
            },
            'Leesstrategieën': {  
              code: '2A6',
              description: 'Flexibel toepassen van verschillende aanpakken en begripsverhogende strategieën'
            }
          }
        },
        'Evaluatie': {
          code: '2B',
          description: 'De leerling evalueert en reflecteert op zakelijke en literaire teksten',
          isLeaf: level2leaf,
          children: {
            'Relaties binnen en tussen teksten': {
              code: '2B1',
              description: 'Benoemen van inhoudelijke relaties binnen en tussen verschillende teksten'
            },
            'Vergelijken van teksten': {  
              code: '2B2',
              description: 'Benoemen van verschillen en overeenkomsten in feiten, meningen, argumentatie en perspectieven'
            },
            'Tegenstrijdigheden en framing': {
              code: '2B3',
              description: 'Benoemen van tegenstrijdige en overeenkomstige inhoud en framing binnen en tussen teksten'
            },
            'Evalueren bruikbaarheid': {
              code: '2B4',
              description: 'Evalueren van bruikbaarheid van teksten'
            },
            'Reflecteren op teksten': {
              code: '2B5',
              description: 'Reflecteren op de waarde, inhoud en vorm van teksten'
            }
          }
        },
        'Betrouwbaarheid': {
          code: '2C',
          description: 'De leerling verkent de betrouwbaarheid van verschillende bronnen',
          isLeaf: level2leaf,
          children: {
            'Kenmerken van bronnen': {
              code: '2C1',
              description: 'Benoemen van kenmerken van aangereikte bronnen: maker, tekstsoort en verschijningsdatum'
            },
            'Benoemen misleiding': {
              code: '2C2',
              description: 'Benoemen van inhouds- en vormelementen die misleidend zijn of vragen oproepen'
            },
            'Beoordelen en selecteren': {
              code: '2C3',
              description: 'Vergelijkend beoordelen en selecteren van bronnen op basis van hun betrouwbaarheid'
            }        
          }
        }
      }
    },
    'Tekstproductie': {
      code: '3',
      children: {
        'Spreken en schrijven': {
          code: '3A',
          description: 'De leerling spreekt en schrijft afgestemd op doel, publiek en context',
          isLeaf: level2leaf,
          children: {
            'Afstemming op doel/publiek/context': { 
              code: '3A1',
              description: 'Hanteren van een passende aanpak'
            },
            'Werken met bronnen': {
              code: '3A2',
              description: 'In eigen woorden verwerken van informatie uit verschillende bronnen tot een gestructureerde tekst met bronvermelding'
            },
            'Kennis tekstvorm inzetten': {
              code: '3A3',
              description: 'Inzetten en uitbreiden van kennis over de vorm van teksten: tekstsoorten, tekststructuren, verteltechnieken'
            },
            'Leesbaar schrijven/spreken': { 
              code: '3A4',
              description: 'Schrijven op letter-, schrift- en tekstniveau met een leesbaar handschrift en typschrift, en verstaanbaar spreken'
            },
            'Reviseren': {
              code: '3A5',
              description: 'Reviseren van de tekst met het oog op doelgerichte communicatie: taalgebruik en taalverzorging'
            }
          }
        
        },
        'Creatief taalgebruik': {
          code: '3B',
          isLeaf: level2leaf,
          children: {

            'Creatief taalgebruik verkennen': {
              code: '3B1',
              description: 'Verkennen van creatief taalgebruik van anderen in literaire en zakelijke teksten'
            },
            'Gedachten/gevoelens verwoorden': {
              code: '3B2',
              description: 'Verwoorden van eigen gedachten, ervaringen, gevoelens en fantasieën'
            },
            'Experimenteren met taal': {  
              code: '3B3',
              description: 'Experimenteren met klanken, woorden, zinnen, literaire genres, taalregels, taalconventies en visuele vormen'
            },
            'Eigen stijl verkennen': {
              code: '3B4',
              description: 'Verkennen van kenmerken van de ontluikende eigen stijl en het talige repertoire'
            },
            'Creatief taalgebruik waarderen': {
              code: '3B5',
              description: 'Waarderen van creatief taalgebruik'
            }
          }
        },
        'Schrijven voor kennisopbouw': {
          code: '3C',
          description: 'De leerling schrijft om tot kennisopbouw of begrip te komen',
          isLeaf: level2leaf,
          children: {
            'Hoofd- en bijzaken en indrukken weergeven': {
              code: '3C1',
              description: 'Weergeven van hoofd- en bijzaken, indrukken en vragen bij gelezen, bekeken of beluisterde inhoud'
            },
            'Samenvatten': {
              code: '3C2',
              description: 'Samenvatten van gelezen inhoud'
            },
            'Informatie ordenen': {
              code: '3C3',
              description: 'Verwoorden, onderbouwen en ordenen van gedachten, verworven inzichten en kennis in een tekst of schema'
            },
            'School- en vaktaal inzetten': {
              code: '3C4',
              description: 'Inzetten en uitbreiden van school- en vaktaal'
            },
            'Leesbaar handschrift/typschrift': {
              code: '3C5',
              description: 'Schrijven op letter-, schrift- en tekstniveau met een leesbaar handschrift en typschrift'
            }
          }
        }
      }
    },
    'Gesprekken': {
      code: '4',
      children: {
        'Gesprekken voeren': {
          code: '4A',
          description: 'De leerling voert gesprekken afgestemd op doel, gesprekspartner(s) en context',
          isLeaf: level2leaf,
          children: {
            'Constructief gesprek voeren': {
              code: '4A1',
              description: 'Inzetten en uitbreiden van vaardigheden om gesprekken constructief te laten verlopen: luisteren, herkennen van signalen en passend reageren op de gesprekspartner(s)'
            },
            'Actief deelnemen': {
              code: '4A2',
              description: 'Actief deelnemen aan gesprekken'
            },
            'Afstemmen op doel en context': {
              code: '4A3',
              description: 'Afstemmen van taalgebruik, stemgebruik en non- verbale communicatie op communicatief doel en on- en offline context'
            },
            'Afstemmen op gesprekspartner': {
              code: '4A4',
              description: 'Verwerven en gebruiken van informatie afgestemd op kennis, achtergrond, standpunt en perspectief van de gesprekspartner(s)'
            },
            'Conventies toepassen': {
              code: '4A5',
              description: 'Toepassen van gespreks- en taalconventies, passend bij de gespreksvorm'
            }
          }
        },
        'Gesprekken voor begrip/aanpak': {
          code: '4B',
          description: 'De leerling voert gesprekken om tot kennisopbouw, begrip of een aanpak te komen',
          isLeaf: level2leaf,
          children: {
            'Ideeën/standpunten verwoorden': {
              code: '4B1',
              description: 'Verwoorden van kennis, ideeën en standpunten met onderbouwing'
            },
            'Vragen om toelichting/verklaring': {
              code: '4B2',
              description: 'Vragen om toelichting, verklaring of bevestiging'
            },
            'Doorvragen/ter discussie stellen': {
              code: '4B3',
              description: 'Luisteren naar, doorvragen op en ter discussie stellen van de ideeën en perspectieven van gesprekspartners'
            },
            'Accepteren/verwerpen met argumenten': {
              code: '4B4',
              description: 'Accepteren of verwerpen van andermans ideeën met argumenten'
            },
            'Samenvatten/conclusies trekken': {
              code: '4B5',
              description: 'Samenvatten van inzichten, verwoorden van oplossingen of trekken van conclusies'
            }
          }
        }
      }
    },
    'Reflectie': {
      code: '5',
      children: {
        'Proces en product': {
          code: '5A',
          description: 'De leerling reflecteert op het proces en evalueert het product van een taalactiviteit',
          isLeaf: level2leaf,
          children: {
            'Feedback ontvangen en geven': {
              code: '5A1',
              description: 'Ontvangen en geven van feedback'
            },
            'Reflecteren op aanpak/strategieën': {
              code: '5A2',
              description: 'Reflecteren op het proces: de gemaakte keuzes in aanpak en strategieën tijdens en na de uitvoering van een taalactiviteit'
            },
            'Product beoordelen met criteria': {
              code: '5A3',
              description: 'Beoordelen van het product van de taalactiviteit aan de hand van aangereikte criteria'
            },
            'Leerdoelen formuleren': {
              code: '5A4',
              description: 'Formuleren van leerdoelen voor proces en product bij toekomstige taalactiviteiten'
            }
          }
        }
      }
    },
      }
    },
    'Taal': {
      children: {
        'Taalsysteem': {
      code: '6',
      children: {
        'Vorm en betekenis': {
          code: '6A',
          description: 'De leerling beschouwt de relatie tussen vorm en betekenis van taal',
          isLeaf: level2leaf,
          children: {
            'Vorm en betekenis verkennen': {
              code: '6A1',
              description: 'Verkennen hoe letterklanken, klemtoon, intonatie en ritme samenhangen met de betekenis van taal'
            },
            'Woordbouw en betekenis': {
              code: '6A2',
              description: 'Inzicht tonen in de opbouw van complexe woorden om de betekenis af te leiden'
            },
            'Zinsbouw en betekenis': {
              code: '6A3',
              description: 'Beschrijven hoe de betekenis in complexe zinnen bepaald wordt door de woordvolgorde en de zinsdelen'
            },
            'Register/stijl/opbouw en doel': {
              code: '6A4',
              description: 'Verkennen hoe register, stijlmiddelen en opbouw van teksten een relatie hebben met het communicatieve doel'
            },
            'Taalkundige begrippen': {
              code: '6A5',
              description: 'Functioneel gebruiken van taalkundige begrippen en taalbeschouwingsstrategieën bij het redeneren over de spelling en grammatica'
            }
          }
        },
        'Spelling en formulering': {
          code: '6B',
          description: 'De leerling toont inzicht in regels en procedures voor spelling, formulering en interpunctie',
          isLeaf: level2leaf,
          children: {
            'Correct formuleren': {
              code: '6B1',
              description: 'Correct formuleren op woord-, zins- en tekstniveau'
            },
            'Spelling herleiden': {
              code: '6B2',
              description: 'Verbinden van vorm en betekenis om de correcte spelling te achterhalen'
            },
            'Spellingbewustzijn ontwikkelen': {
              code: '6B3',
              description: 'Ontwikkelen van spellingbewustzijn en spellinggeweten'
            },
            'Reflecteren op woord-/zinskeuzes': {
              code: '6B4',
              description: 'Reflecteren op gemaakte keuzes in woorden en zinnen'
            },
            'Hulpmiddelen/bronnen gebruiken': {
              code: '6B5',
              description: 'Inzetten van hulpmiddelen en bronnen om regels en procedures correct toe te passen en teksten te redigeren'
            }
          }
        },
        'Zakelijke genres': {
          code: '6C',
          only: 'havo/vwo',
          description: 'De leerling toont inzicht in zakelijke genres',
          isLeaf: level2leaf,
          children: {
            'Kenmerken benoemen': {
              code: '6C1',
              description: 'Benoemen van kenmerken met betrekking tot context, doel, inhoud en vorm, passend bij een genre'
            },
            'Specifiek taalgebruik herkennen': {
              code: '6C2',
              description: 'Herkennen van genrespecifieke kenmerken van taalgebruik'
            },
            'Reflecteren op genrekenmerken': {
              code: '6C3',
              description: 'Reflecteren op gebruik van genrekenmerken in relatie tot het communicatieve doel'
            }
          }
        },
        'Overtuigingskracht': {
          code: '6D',
          only: 'havo/vwo',
          description: 'De leerling verkent de overtuigingskracht van teksten',
          isLeaf: level2leaf,
          children: {
            'Standpunt en argumenten herkennen': {
              code: '6D1',
              description: 'Herkennen van standpunt en argumenten in teksten'
            },
            'Context herkennen': {
              code: '6D2',
              description: 'Herkennen van de context waarin de argumentatie plaatsvindt'
            },
            'Geloofwaardigheid verkennen': {
              code: '6D3',
              description: 'Verkennen van de geloofwaardigheid van de spreker of schrijver'
            },
            'Gevoelens oproepen': {
              code: '6D4',
              description: 'Beschrijven hoe gevoelens worden opgeroepen bij het publiek'
            }
          }
        }
      }
    },
    'Taalgebruik': {
      code: '7',
      children: {
        'Taal en identiteit': {
          code: '7A',
          isLeaf: level2leaf,
          children: {
            'Repertoire en taalvariëteiten verkennen': {
              code: '7A1',
              description: 'Verkennen van het eigen talige repertoire in relatie tot hoe je wilt overkomen en tot welke groepen je wilt behoren: talen en taalvariëteiten, gebaren, lichaamstaal'
            },
            'Experimenteren met eigen repertoire': {
              code: '7A2',
              description: 'Experimenteren met het eigen talige repertoire in relatie tot publiek, doel en context'
            },
            'Reflecteren op hoe je overkomt': {
              code: '7A3',
              description: 'Reflecteren op hoe je overkomt op anderen op basis van bewuste keuzes in het eigen talige repertoire'
            },
            'Reflecteren op taal van anderen': {
              code: '7A4',
              description: 'Reflecteren op hoe andere mensen hun talige repertoire benutten om uiting te geven aan hun identiteit'
            },
            'Eigen repertoire waarderen': {
              code: '7A5',
              description: 'Waarderen van het eigen talige repertoire'
            }
          }
        },
        'Taalvariatie en verandering': {
          code: '7B',
          isLeaf: level2leaf,
          children: {
            'Taalvariëteiten verkennen': {
              code: '7B1',
              description: 'Verkennen van verschillende taalvariëteiten van het Nederlands: school- en vaktaal, groeps- en streektalen en talen in beroepscontexten'
            },
            'Contexten vergelijken': {
              code: '7B2',
              description: 'Vergelijken van de contexten waarin verschillende talen en taalvariëteiten worden gebruikt'
            },
            'Talen/variëteiten vergelijken': {
              code: '7B3',
              description: 'Benoemen van overeenkomsten en verschillen tussen het Nederlands en andere talen en taalvariëteiten op klank-, woord- en zinsniveau'
            },
            'Reflecteren op overtuigingen over taal': {
              code: '7B4',
              description: 'Reflecteren op overtuigingen over verschillende talen en taalvariëteiten'
            },
            'Taalverandering verkennen': {
              code: '7B5',
              description: 'Verkennen van veranderingen in taalgebruik onder invloed van tijd, media en maatschappelijke ontwikkelingen'
            }
          }
        }
      }
    }
      }
    },
    'Literatuur': {
      children: {
        'Literatuurervaring': {
      code: '8',
      children: {
        'Leesvoorkeur': {
          code: '8A',
          isLeaf: level2leaf,
          children: {
            'Literaire teksten lezen/beluisteren': {
              code: '8A1',
              description: 'Lezen en beluisteren van boeken en teksten, van verschillende schrijvers en literaire genres'
            },
            'Waardeoordeel geven': {
              code: '8A2',
              description: 'Geven van een waardeoordeel over gelezen of beluisterde boeken en teksten op basis van literaire genres, eigen interesse en belevingswereld'
            },
            'Nieuwe leesuitdagingen aangaan': {
              code: '8A3',
              description: 'Aangaan van nieuwe leesuitdagingen op basis van eerdere lees-, luister- en kijkervaringen'
            },
            'Voorkeur beargumenteren': {
              code: '8A4',
              description: 'Beargumenteren van persoonlijke voorkeur op basis van reflectie op ervaringen met literatuur'
            }
          }
        },
        'Waarde van literatuur': {
          code: '8B',
          isLeaf: level2leaf,
          children: {
            'Leeservaring/-beleving verwoorden': {
              code: '8B1',
              description: 'Verwoorden van persoonlijke leeservaring en -beleving na het lezen van literatuur'
            },
            'Inzichten over jezelf': {
              code: '8B2',
              description: 'Verwoorden van opgedane inzichten en kennis over zichzelf op basis van literatuur'
            },
            'Inzichten over anderen': {
              code: '8B3',
              description: 'Verwoorden van opgedane inzichten en kennis over anderen op basis van literatuur'
            },
            'Inzichten over wereld/culturen': {
              code: '8B4',
              description: 'Verwoorden van opgedane inzichten en kennis over de wereld en culturen op basis van literatuur'
            }
          }
        }
      }
    },
    'Literatuurinzicht': {
      code: '9',
      children: {
        'Verhalende teksten': {
          code: '9A',
          isLeaf: level2leaf,
          children: {
            'Verhaalontwikkeling': {
              code: '9A1',
              description: 'Beschrijven welk probleem of welke wens van een hoofdpersoon de motor van het verhaal is en hoe het verhaal zich ontwikkelt'
            },
            'Personages': {
              code: '9A2',
              description: 'Beschrijven van de verschillende rollen van personages, hun karakter en ontwikkeling'
            },
            'Verteltechnieken en effect': {
              code: '9A3',
              description: 'Beschrijven hoe een schrijver verschillende verteltechnieken gebruikt om bepaalde effecten te bereiken'
            },
            'Tijd/plaats/omstandigheden': {
              code: '9A4',
              description: 'Beschrijven hoe tijd, plaats en omstandigheden het verhaal beïnvloeden'
            }
          }
        },
        'Genrekenmerken': {
          code: '9B',
          isLeaf: level2leaf,
          children: {
            'Poëzie/proza/drama onderscheiden': {
              code: '9B1',
              description: 'Onderscheiden van poëzie-, proza- en dramateksten op basis van genrekenmerken'
            },
            'Effect van genrekenmerken op leesbeleving': {
              code: '9B2',
              description: 'Benoemen van het effect op de leesbeleving van verschillende genrekenmerken'
            },
            'Taalgebruik analyseren': {
              code: '9B3',
              description: 'Analyseren van kenmerkend taalgebruik in literaire genres: figuurlijk taalgebruik, stijlfiguren, rijm en ritme'
            },
            'Visuele elementen analyseren': {
              code: '9B4',
              description: 'Analyseren van kenmerkende visuele elementen in literaire genres: illustraties, vormgeving, typografie'
            }
          }
        },
        'Periodes en context verkennen': {
          code: '9C',
          isLeaf: level2leaf,
          children: {
            'Literatuur uit verschillende tijden': {
              code: '9C1',
              description: 'Lezen, bekijken of beluisteren van literatuur uit verschillende tijden'
            },
            'Tijd en context verkennen': {
              code: '9C2',
              description: 'Verkennen van de tijd en context waarin het verhaal geschreven is'
            },
            'Vergelijken historische teksten en eigen tijd': {
              code: '9C3',
              description: 'Verwoorden van verschillen en overeenkomsten tussen historische teksten en de eigen tijd, leef- en belevingswereld'
            },
            'Universele thema\'s door de tijd heen': {
              code: '9C4',
              description: 'Verwoorden van universele thema\'s in literatuur door de tijd heen'
            }
          }
        },
        'Periode en context beschrijven': {
          code: '9D',
          only: 'havo/vwo',
          isLeaf: level2leaf,
          children: {
            'Oude en hedendaagse literatuur vergelijken': {
              code: '9D1',
              description: 'Beschrijven van verschillen en overeenkomsten tussen oudere en hedendaagse literatuur'
            },
            'Versies van een tekst vergelijken': {
              code: '9D2',
              description: 'Beschrijven van verschillen en overeenkomsten tussen versies van literaire teksten'
            },
            'Relatie periode en wereldbeeld schrijver': {
              code: '9D3',
              description: 'Beschrijven van relaties tussen de periode en context waarin de tekst is geschreven en het wereldbeeld van de schrijver'
            },
            'Inzicht in tijdvakken': {
              code: '9D4',
              description: 'Beschrijven van opgedane inzichten over historische tijdvakken'
            },
            'Literair-culturele sporen': {
              code: '9D5',
              description: 'Herkennen van literair-culturele sporen in literatuur uit heden en verleden'
            }
          }
        }
      }
    }
      }
    }
  }
}